import { render, staticRenderFns } from "./Footer01.vue?vue&type=template&id=d9934b82&"
import script from "./Footer01.vue?vue&type=script&lang=js&"
export * from "./Footer01.vue?vue&type=script&lang=js&"
import style0 from "./Footer01.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
